import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-user-group-members-modal',
  templateUrl: './delete-user-group-members-modal.component.html',
  styleUrls: ['./delete-user-group-members-modal.component.css'],
})
export class DeleteUserGroupMembersModalComponent implements OnInit {
  constructor(private ngbActiveModal: NgbActiveModal) {}

  ngOnInit(): void {}

  deleteClicked() {
    this.ngbActiveModal.close('delete');
  }

  cancelClicked() {
    this.ngbActiveModal.close('cancel');
  }
}
